import { Flex, Spinner, Text } from "@chakra-ui/react";

export type LoadingScreenProps = {
  loadingText?: string;
  isFullScreen?: boolean;
};

export function LoadingScreen({
  loadingText,
  isFullScreen,
}: LoadingScreenProps) {
  return (
    <Flex
      justify={"center"}
      align={"center"}
      minH={"400px"}
      h={isFullScreen ? "100vh" : "auto"}
      direction={"column"}
      gap={4}
    >
      <Spinner size={"xl"} />
      {loadingText && <Text>{loadingText}</Text>}
    </Flex>
  );
}
